import {rpcCall} from "../../util/rpc/rpcCalls";
import {UserGroupsDisabledError, NoRightsToManageAccountSettingsError, GroupExistsError} from "../errors";

export default class ATUserGroupManagementService {
    createUserGroup(group) {
        return rpcCall("ATUserGroupManagementService.createUserGroup", [group], this._rpcErrorHandler)
    }

    _rpcErrorHandler(rpcError) {
        rpcError.handleOnException('com.actimind.common.services.UserGroupsDisabledException', new UserGroupsDisabledError());
        rpcError.handleOnException('com.actimind.actitime.services.NoRightsToManageAccountSettings', new NoRightsToManageAccountSettingsError());
        rpcError.handleOnException('com.actimind.actitime.administration.GroupExistsException', new GroupExistsError());
    }
}


// WEBPACK FOOTER //
// ./web/js/groupManagement/rpc/ATUserGroupManagementService.js